const { Box, Typography } = require('@mui/material');

function CustomTabPanel({ children, value, index, ...other }) {
  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ width: '100%' }}>
      {value === index && (
        <Box sx={{ p: 3, overflowX: 'auto', maxWidth: '100vw' }}>
          <Typography component='div'>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export default CustomTabPanel;
